import { render, staticRenderFns } from "./TabelUndangUndang.vue?vue&type=template&id=6a779d23&scoped=true"
import script from "./TabelUndangUndang.vue?vue&type=script&lang=js"
export * from "./TabelUndangUndang.vue?vue&type=script&lang=js"
import style0 from "./TabelUndangUndang.vue?vue&type=style&index=0&id=6a779d23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a779d23",
  null
  
)

export default component.exports